/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type RoutePlanWarningEnum =
  (typeof RoutePlanWarningEnum)[keyof typeof RoutePlanWarningEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoutePlanWarningEnum = {
  ContainsOnHold: 0,
  HotelNeeded: 10,
  HotelNeededButCannotStayAtHotels: 11,
  BreakTimeInsufficient: 20,
  DayBreakTimeInsufficient: 21,
  StartsAwayFromHome: 30,
  EndsAwayFromHome: 31,
  ReturnByPersonalTransport: 32,
  LongCommute: 33,
  DrivingPolicyBlocked: 40,
  EstimatesOnly: 50,
  DriverSwapSuggested: 60,
  ShortFullTimeDay: 70,
  RevenueFromLowestRoutePrice: 80,
  EmergencyCapability: 90,
  OutsideScheduleWithinTolerance: 100,
  LowRangeElectricTruckRecommended: 110,
  LoneLegCouldWait: 120,
  MissesExistingAssignment: 130,
  DayExceedsMaxWorkingHours: 140,
} as const;
